import {
	ButtonBase,
	Collapse,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, useState } from "react";
import type { GetTaskWorkflowStepResponse } from "web_myplann/Infrastructure/Api/Api";
import { TaskSubtaskRow } from "web_myplann/Tasks/Components/TaskSubtaskRow";

type Props = {
	name: string;
	steps: GetTaskWorkflowStepResponse[];
	showDivider: boolean;
};

export const TaskPhaseBlock: FC<Props> = ({ name, steps, showDivider }) => {
	const { palette, iconSize, spacingTokens } = useTheme();
	const [open, setOpen] = useState(true);

	const Chevron = open ? ChevronUp : ChevronDown;

	return (
		<Stack borderBottom={showDivider ? 1 : 0} borderColor="surface.border">
			<ButtonBase
				aria-expanded={open}
				onClick={() => setOpen((value) => !value)}
				sx={{ "&:active": { bgcolor: "grey.50" } }}
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					gap={spacingTokens.md}
					width="100%"
					px={spacingTokens.lg}
					pt={spacingTokens.md}
					pb={spacingTokens.xs}
					textAlign="left"
				>
					<Typography variant="bodyStrong">{name}</Typography>
					<Chevron
						size={iconSize.sm}
						color={palette.grey[400]}
						style={{ flexShrink: 0 }}
					/>
				</Stack>
			</ButtonBase>
			<Collapse in={open} timeout="auto">
				{steps.map((step, index) => (
					<TaskSubtaskRow
						key={step.taskWorkflowStepID}
						data={step}
						isFirst={index === 0}
						isLast={index === steps.length - 1}
					/>
				))}
			</Collapse>
		</Stack>
	);
};
